import {allProductsUrl} from "../Elements/consts";

export const setPageInfo = (uri, title = null) => {
    window.history.pushState("object or string", "Title", `${uri}`);
    if (title) document.title = title;
};

export const setCategoryPageInfo = category => {
    category.seo && category.uri && setPageInfo(`${category.uri}`, category.seo.title);
};

export const setViewProductsPageInfo = () => {
    setPageInfo(allProductsUrl, 'View all products');
};

export const setCategoryById = (id, productCategories) => {
    const categoryFilter = productCategories.data.productCategories.nodes.filter(categoryItem => categoryItem.databaseId === id);
    return categoryFilter[0];
};

export const resetOffset = (setPaged) => {
    setPaged(prevPage => ({size: parseInt(prevPage.size), offset: 0}));
};

export const toggleFilters = () => {
    const bodyTag = document.querySelector('body');
    bodyTag.classList.toggle('filters-open')
};
